/**
 * Who a flow definition template is discoverable by.
 *
 * Global templates are discoverable by every caller. Organization and Private templates are
 * discoverable by members of the owning organization, and Private additionally by its creator:
 * Private marks a template as a draft that is not promoted in the library, not one hidden from
 * colleagues who can access the organization.
 */
export var FlowDefinitionTemplateVisibility;
(function (FlowDefinitionTemplateVisibility) {
    FlowDefinitionTemplateVisibility["Private"] = "Private";
    FlowDefinitionTemplateVisibility["Organization"] = "Organization";
    FlowDefinitionTemplateVisibility["Global"] = "Global";
})(FlowDefinitionTemplateVisibility || (FlowDefinitionTemplateVisibility = {}));
//# sourceMappingURL=visibility.js.map